// shared/components/DisabledOverlay/DisabledOverlay.tsx
import { Box, Typography, alpha } from "@mui/material";
import React from "react";

interface DisabledOverlayProps {
	message?: string;
}

export function DisabledOverlay({ message = "Crie e salve o envelope para habilitar esta seção." }: DisabledOverlayProps) {
	return (
		<Box
			sx={{
				position: "relative",
				minHeight: 120,
				"&::after": {
					content: '""',
					position: "absolute",
					inset: 0,
					bgcolor: (t) => alpha(t.palette.background.default, 0.65),
					borderRadius: 1,
					zIndex: 1,
				},
			}}
		>
			<Box sx={{ position: "relative", zIndex: 2, p: 2, textAlign: "center" }}>
				<Typography variant="body2" color="text.secondary">
					{message}
				</Typography>
			</Box>
		</Box>
	);
}
